import {register} from '@shopify/theme-sections';

export default register('hero-banner', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';
    // Parse the settings string passed through from liquid
    this.userSettings = JSON.parse(this.settings);
    const thisBanner = document.querySelector(`#hero-banner--${this.id}`);
    const imageHeightEl = thisBanner.querySelector('.image-height');
    const textContainer = thisBanner.querySelector('.hero-banner__container');

    // Check if height is natural and if the measurable height element exists
    if (this.userSettings.slider_height_type === 'natural' && imageHeightEl) {
      // Set a variable of the measurable element
      let contentHeight = imageHeightEl.offsetHeight;
      let resizeTimer;
      // Set the height of the content element based on the measurable element
      textContainer.style.height = `${contentHeight}px`;

      // Update these values on resize with a debounce
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          contentHeight = imageHeightEl.offsetHeight;
          textContainer.style.height = `${contentHeight}px`;
        }, 250);
      });
    }
  },
});
